import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import SingleColumnGridIcon from '../../../../../components/icons/SingleColumnGridIcon';
import DoubleColumnGridIcon from '../../../../../components/icons/DoubleColumnGridIcon';
import TripleColumnGridIcon from '../../../../../components/icons/TripleColumnGridIcon';
import Button from '../../../../../components/global/Button';

export const GRID_TYPES = {
  SINGLE: 'SINGLE',
  DOUBLE: 'DOUBLE',
  TRIPLE: 'TRIPLE',
};

const propTypes = {
  onGridTypeChange: PropTypes.func.isRequired,
};

const CardElementPhotoSelectionControlGridSelect = ({ onGridTypeChange }) => {
  const [gridType, setGridType] = useState(GRID_TYPES.SINGLE);

  useEffect(() => {
    onGridTypeChange(gridType);
  }, [gridType]);

  return (
    <div className="card-element-photo-selection-control-grid-select">
      <Button
        btnStyle="reset"
        onClick={() => setGridType(GRID_TYPES.SINGLE)}
        className={classNames({
          'grid-select-btn': true,
          'is-active': gridType === GRID_TYPES.SINGLE,
        })}
      >
        <SingleColumnGridIcon />
      </Button>
      <Button
        btnStyle="reset"
        onClick={() => setGridType(GRID_TYPES.DOUBLE)}
        className={classNames({
          'grid-select-btn': true,
          'is-active': gridType === GRID_TYPES.DOUBLE,
        })}
      >
        <DoubleColumnGridIcon />
      </Button>
      <Button
        btnStyle="reset"
        onClick={() => setGridType(GRID_TYPES.TRIPLE)}
        className={classNames({
          'grid-select-btn': true,
          'is-active': gridType === GRID_TYPES.TRIPLE,
        })}
      >
        <TripleColumnGridIcon />
      </Button>
    </div>
  );
};

CardElementPhotoSelectionControlGridSelect.propTypes = propTypes;

export default CardElementPhotoSelectionControlGridSelect;
